module.exports = __webpack_public_path__ + "img/geo-zones-3.4a1a2f37.gif";